(function ($) {
  jQuery.fn.setButtonActions = function (inputName) {

    var actionInput = this.find('input[name=' + inputName + ']');

    this.find('input[type="submit"]').click(function() {
      actionInput.val($(this).data('action'));
    });
  };
}(jQuery));
